module.exports = __webpack_public_path__ + "static/media/secretaria.4eeb1f39.svg";